module.exports = __webpack_public_path__ + "img/3.c37479bf.svg";